"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getEnrolmentOfContent_1 = tslib_1.__importDefault(require("../../helpers/enrolment/getEnrolmentOfContent"));
const getAssignedEvent_1 = require("../../helpers/getEvent/getAssignedEvent");
function addAssignEvent(command, enrolments, user, content, events) {
    const enrolment = getEnrolmentOfContent_1.default(enrolments, content._id, user.userId);
    if (enrolment) {
        const assignedEvent = getAssignedEvent_1.getContentAssignedEvent(command, user, content, enrolment);
        events.push(assignedEvent);
    }
}
exports.default = addAssignEvent;
//# sourceMappingURL=addAssignEvent.js.map